import React, { FC } from 'react';
import Phone from 'react-phone-number-input';

import FormFieldWrapper from '../Wrapper';

const PhoneInputFormField: FC<any> = ({ name, label, help, ...props }) => (
  <FormFieldWrapper
    name={name}
    label={label}
    help={help}
    render={fieldProps => <Phone {...props} {...fieldProps} />}
  />
);

export default PhoneInputFormField;
